import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { startListApi } from '../startListApi';
import type { ReorderStartListEntryRequest } from '../../types/startList';

export const startListQueryKey = (groupId: number) => ['start-list', groupId] as const;

export const useStartList = (groupId: number, enabled: boolean = true) =>
  useQuery({
    queryKey: startListQueryKey(groupId),
    queryFn: () => startListApi.getStartList(groupId),
    enabled: !!groupId && enabled,
  });

export const useGenerateStartList = (groupId: number) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => startListApi.generate(groupId),
    onSuccess: (data) => {
      qc.setQueryData(startListQueryKey(groupId), data);
    },
  });
};

export const useReorderStartListEntry = (groupId: number) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ entryId, req }: { entryId: number; req: ReorderStartListEntryRequest }) =>
      startListApi.reorderEntry(entryId, req),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: startListQueryKey(groupId) });
    },
  });
};
